import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { style: {"z-index":"5000"} }
const _hoisted_3 = {
  key: 0,
  class: "content",
  style: {"display":"block","width":"100vw","height":"calc(100vh - 70px)"}
}
const _hoisted_4 = {
  key: 1,
  class: "forbidden"
}

import { onMounted, ref } from "vue";

import LogoIcon from "@/assets/LogoIcon.vue";
import { getIsPassphraseValid } from "@/utils/helpers";
import ParticipantIdModal from "@/components/ParticipantIdModal.vue";

// ---- STATE ----

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isPassphraseValid = ref(false);

// ---- LIFECYCLE HOOKS ----

onMounted(async () => {
  isPassphraseValid.value = await getIsPassphraseValid();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(LogoIcon, { style: {"width":"60px"} }),
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "app-title" }, "EEG Recording", -1))
    ]),
    (isPassphraseValid.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "403 Forbidden")),
    _createVNode(ParticipantIdModal)
  ]))
}
}

})